export const BRAND = {
  terracotta: "#B24F36",
  terracottaDark: "#A93F2B",
  terracottaSoft: "#FCE7DD",
  cream: "#FFF8F3",
  warmBg: "#F7EFE8",
  navy: "#0B2454",
  text: "#1E1E1E",
  muted: "#5B6474",
};

export const WHATSAPP_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER || "";